import {GIFT_SHOP_CACHE_TTL_MS} from 'consts'
import {reduxSelector, reduxUpdateDispatcher} from 'lib/redux'
import {requestData} from 'services'
import {GiftshopFollowCountResponse} from 'types'

let lastFetch = 0
let activeFetchPromise: Promise<GiftshopFollowCountResponse | null> | null = null

function isCacheValid(): boolean {
  const {followerCount, followingCount} = reduxSelector(
    'forkygramHomefeedsState',
  )
  const isDataMissing =
    followerCount === undefined || followingCount === undefined
  const isCacheExpired = Date.now() - lastFetch > GIFT_SHOP_CACHE_TTL_MS

  return !isCacheExpired && !isDataMissing
}

function getMapReduxCache(): GiftshopFollowCountResponse | null {
  const state = reduxSelector('forkygramHomefeedsState')
  if (!isCacheValid()) return null

  return {
    follower_count: state.followerCount!,
    following_count: state.followingCount!,
  }
}

async function fetchData(): Promise<GiftshopFollowCountResponse | null> {
  try {
    const response = await requestData('giftshop_get_follow_count', {
      params: {member_id: reduxSelector('user')?.id || ''},
    })
    if (typeof response !== 'string' && response.status === 200) {
      lastFetch = Date.now()
      const {result} = response.data

      reduxUpdateDispatcher('forkygramHomefeedsState', {
        followerCount: result.follower_count,
        followingCount: result.following_count,
      })
      return result
    }
  } catch (e) {
    console.error(e)
  } finally {
    activeFetchPromise = null
  }
  return getMapReduxCache()
}

export async function handleMemberGetFollowCount(
  forceRequest = false,
): Promise<GiftshopFollowCountResponse | null> {
  if (activeFetchPromise) return activeFetchPromise

  if (forceRequest || !isCacheValid()) {
    activeFetchPromise = fetchData()

    return activeFetchPromise
  }

  return getMapReduxCache()
}
